import Widget from './Widget'
export default Widget

import {IMAGE_TYPES, IMAGE_TYPE_NAMES} from './image-types'

export {
  IMAGE_TYPES,
  IMAGE_TYPE_NAMES,
}